export default {
    risksMenu: 'Risk Analysis',
    riskMaps: 'Heat maps',
    riskMapsMenu: 'Risk Assessment',
    risks: 'Risks',
    totalRisks: 'Total risks',
    valoratedRisks: 'Analyzed risks',
    risksOfThreat: 'Risks of the threat',
    probability: 'Probability',
    showAssetsRisk: 'Show risky assets',
    showCriticalAssets: 'Show critical assets',
    threatCategory: 'Category/Subcategory',
    threatAsset: 'Threat/Asset',
    selectMeasure: 'Select a rating or qualification',
    selectProbability: 'Select a probability',
    noFactorsMessage: 'you have not yet selected the impact factors that apply to this asset. You can go to the Asset Criticality tab to do this process.',
    defineCriticy: 'Define criticality of the asset',
    noThreatsMessage: 'this asset has no associated threats yet. To carry out the risk validation, it is necessary to identify the possible threats that could affect this asset.',
    identify: 'Identify',
    riskLevel: 'Risk Level',
    saveRisk: 'Save Risk',
    risk: 'Risk',
    noRiskZone: 'No risk on this zone',
    riskRecognition: 'Risk recognition',
    noRisksMessage: 'You still do not have calculated risks, if you want to calculate the risk of your assets, you can do so in the risk calculation section.',
    riskGuideMessage: 'The risk level is automatically calculated by multiplying the probability of an event occurring by the potential impact on the asset, providing an accurate assessment of the risk with respect to its associated threats.',
    riskZoneMapsGuideMessage: 'This module allows you to clearly visualize the risk levels associated with your organization\'s assets through a color-coded matrix based on likelihood and impact. This helps prioritize the appropriate controls.',
    noAssetsMessageTitle: 'You have no assets to risk assess.',
    noAssetsMessage: 'To assess risks, you must first create an asset.',
    noRisksMessageTitle: 'You dont have calculated risks yet.',
    noRisksControlMessageTitle: 'You dont have controls created yet.',
    noRisksControlMessage: 'If you want to create controls for your risks, you can do so in the risk calculation section.',
    noRisksFollowMessageTitle: 'You have no risks to track yet.',
    noRisksFollowMessage: 'If you want to calculate the risk of your assets, you can do so in the risk calculation section.',
    riskStatus: 'Risk Status',
    saveControlError: 'Error saving control',
    controlUpdated: 'Control updated',
    controlUpdateError: 'Error updating control',
    controlActionError: 'Error fetching control actions',
    errorLoadingControls: 'Error loading controls',
    participantError: 'Error loading participants',
    saveFollowError: 'Error saving follow-up',
    followSaved: 'Follow-up saved',
    controlDomainError: 'Error loading control domains',
    controlError: 'Error loading control',
    impactAreaError: 'Error loading impact area',
    controlSaved: 'Control associated successfully',
    riskSaved: 'Risk saved successfully',
    downloadMap: 'Download risk map',
    alerts: {
        incompleteRisk: 'Incomplete Risk',
        incompleteRiskMessage: 'You have threats with selected probability but missing impact factors. Complete the risk assessment before continuing.',
        missingImpactFactors: 'This threat has probability selected but is missing impact factors'
    }

};
